import { useAppSelector } from "../store";
import { ESliceAuth } from '../../store/slices/authSlice'
import { useMemo } from "react";
import { IRoutes } from "../../routes/route.interface";
import { filterRouteObjectBypermission } from "../../routes/routeTool"
import { routes } from "../../routes/routeObject"


const useGetFilterRoutes = (): IRoutes[] => {
  const { permission: permissionList, company_uuid } = useAppSelector(state => state[ESliceAuth.AuthInfo])

  return useMemo<IRoutes[]>(() => {
    if (!company_uuid || permissionList?.length < 1) return routes
    return filterRouteObjectBypermission(routes, permissionList)
  }, [company_uuid, permissionList])

}

export default useGetFilterRoutes
